import React, { useState, useEffect } from "react";

const modalOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "rgba(30,41,59,0.25)",
  zIndex: 9999,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const modalStyle = {
  background: "#fff",
  borderRadius: 18,
  boxShadow: "0 8px 32px 0 rgba(31,38,135,0.18)",
  padding: "2.5rem 2.5rem 2rem 2.5rem",
  minWidth: 340,
  maxWidth: "90vw",
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const inputStyle = {
  padding: "0.7em 1em",
  borderRadius: 8,
  border: "1.5px solid #c7d2fe",
  fontSize: 16,
  width: 260,
  marginBottom: 18,
  outline: "none",
  boxShadow: "0 1px 4px 0 rgba(102,126,234,0.07)",
};

const labelStyle = {
  color: "#64748b",
  margin: "18px 0 10px 0",
  fontSize: 16,
  fontWeight: 500,
  display: "block",
  textAlign: "left",
};

const buttonRowStyle = {
  display: "flex",
  gap: 18,
  marginTop: 8,
  justifyContent: "center",
};

const btnStyle = {
  minWidth: 90,
  fontWeight: 600,
  borderRadius: 8,
  padding: "12px 28px",
  fontSize: 17,
  border: "none",
  cursor: "pointer",
};

const primaryBtn = {
  ...btnStyle,
  background: "#2563eb",
  color: "#fff",
};

const secondaryBtn = {
  ...btnStyle,
  background: "#f3f4f6",
  color: "#374151",
};

const linkBtnStyle = {
  background: "none",
  border: "none",
  color: "#2563eb",
  fontWeight: 500,
  fontSize: 15,
  textDecoration: "underline",
  cursor: "pointer",
  margin: "10px 0 0 0",
  padding: 0,
  transition: "color 0.2s",
  outline: "none",
  display: "inline-block",
};

function UserEditModal({ open, name: initialName, email, onClose, onSubmit }) {
  const [form, setForm] = useState({ name: initialName || "" });
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (open) {
      setForm({ name: initialName || "" });
      setShowPassword(false);
      setPassword("");
    }
  }, [open, initialName]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = { name: form.name };
    if (showPassword && password.trim()) {
      payload.password = password;
    }
    onSubmit(payload);
  };

  if (!open) return null;
  return (
    <div style={modalOverlayStyle}>
      <div style={modalStyle}>
        <h2
          style={{ margin: 0, fontWeight: 700, fontSize: 22, color: "#2563eb" }}
        >
          Edit User
        </h2>
        <form onSubmit={handleSubmit} style={{ width: "100%", marginTop: 18 }}>
          <label style={labelStyle} htmlFor="edit-name">
            Name
          </label>
          <input
            id="edit-name"
            name="name"
            type="text"
            value={form.name}
            onChange={handleChange}
            style={inputStyle}
            required
            autoFocus
          />
          <label style={labelStyle} htmlFor="edit-email">
            Email
          </label>
          <input
            id="edit-email"
            name="email"
            type="email"
            value={email}
            style={{ ...inputStyle, background: "#f3f4f6", color: "#64748b" }}
            disabled
          />
          <div style={{ margin: "10px 0 0 0", minHeight: 40 }}>
            {!showPassword && (
              <button
                type="button"
                style={linkBtnStyle}
                onClick={() => setShowPassword(true)}
                onMouseOver={(e) => (e.currentTarget.style.color = "#1746a2")}
                onMouseOut={(e) => (e.currentTarget.style.color = "#2563eb")}
              >
                Change Password?
              </button>
            )}
            {showPassword && (
              <>
                <label style={labelStyle} htmlFor="edit-password">
                  New Password
                </label>
                <input
                  id="edit-password"
                  name="password"
                  type="password"
                  value={password}
                  onChange={handlePasswordChange}
                  style={inputStyle}
                  placeholder="Enter new password"
                />
              </>
            )}
          </div>
          <div style={{ height: 18 }} />
          <div style={buttonRowStyle}>
            <button type="button" style={secondaryBtn} onClick={onClose}>
              Cancel
            </button>
            <button type="submit" style={primaryBtn}>
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UserEditModal;
